import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import CtaButton from '../../common/CtaButton';
import { getArtworkUrl } from '../utils/Contentful';

const Wrapper = styled.div`
  margin-top: ${props => props.marginTop};
  width: ${props => (props.fullWidth ? '100%' : 'auto')};
`;

const Headline = styled.div`
  font-weight: 600;
  margin-bottom: 1.5rem;
  font-size: var(--fs-s);
`;

const SmallPrint = styled.div`
  margin-top: calc(var(--fr) * 0.75);
  display: flex;
  align-items: center;
  gap: calc(var(--fr) * 0.75);
  color: ${props => props.smallPrintColor || 'inherit'};

  span {
    font-size: var(--fs-base);
  }

  img {
    width: auto;
    height: 26px;
  }
`;

const MainCtaButton = ({ content, marginTop, invertColour, trackingData }) => {
  const {
    label,
    openInNewTab,
    style,
    url,
    headline,
    smallPrintIcon,
    smallPrint,
    smallPrintColor,
    fullWidth,
  } = content;

  const mapStyleToColor = () => {
    switch (style) {
      case 'B/W Filled':
        return invertColour ? 'black' : 'white';
      case 'Red Filled':
        return 'red';
      default:
        return null;
    }
  };

  const mapStyleToOutline = () => {
    switch (style) {
      case 'B/W Transparent with Border':
        return invertColour ? 'black' : 'white';
      default:
        return null;
    }
  };

  return (
    <Wrapper marginTop={marginTop} fullWidth={fullWidth}>
      {headline && <Headline>{headline}</Headline>}
      <CtaButton
        color={mapStyleToColor()}
        link={url}
        outline={mapStyleToOutline()}
        openInNewTab={openInNewTab}
        trackingData={trackingData}
        fullWidth={fullWidth}
      >
        {label}
      </CtaButton>
      <SmallPrint smallPrintColor={smallPrintColor}>
        {smallPrintIcon && <img src={getArtworkUrl(smallPrintIcon)} alt="" />}
        {smallPrint && <span>{smallPrint}</span>}
      </SmallPrint>
    </Wrapper>
  );
};

MainCtaButton.propTypes = {
  content: PropTypes.object,
  marginTop: PropTypes.string,
  invertColour: PropTypes.bool,
  trackingData: PropTypes.object.isRequired,
};

export default MainCtaButton;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/button/MainCtaButton.js